const HubToHub = () => {
  return (
    <div>
  
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
        
          <div className="flex flex-col justify-center">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
              Hub-to-Hub
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              Raw material and unfinished goods are stored, processed, finalised and managed in the logistics hubs, 
              closer to intended customers. The hub also provides a clearing house for data, facilitating digital 
              processing and quality management systems to track and trace shipments.
            </p>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              TCS provides geographically-centred hub locations that bring together the key logistics support services 
              for businesses e.g. manufacturers, distributors, retailers and even third and fourth party logistics providers.
            </p>
              
          </div>
          <div className="flex-1 flex flex-col justify-center lg:mt-[0rem] mt-[1rem]">
              <img src="/overland/Hub-to-Hub-Inside.jpg" alt="" className="max-w-[100%] rounded-md"/>
          </div>
        </div>
      
      </div>
    </div>
  );
};
  
export default HubToHub;
  